import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-500 py-8 text-center px-4" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <p className="text-sm" data-id="element-86">
          &copy; {new Date().getFullYear()} El Método del Sobre Digital. Todos
          los derechos reservados.
        </p>
        <p className="text-xs mt-2 max-w-2xl mx-auto opacity-60" data-id="element-87">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}